import * as React from 'react';
import { BaseTableList } from 'components/AgGrid/AgGrid';
import { ListWrapper } from 'components/AgGrid/CellRenderer/ListView.styled';
import { type WorkOrdersSquare } from 'types/squares.type';
import { useAppSelector } from 'store/hook';
import { convertStdDateString } from 'utils/helpers/dateTime';
import { useTranslation } from 'react-i18next';

interface Props {
  workOrders: WorkOrdersSquare[];
}
export const WorkOrdersList: React.FC<Props> = ({ workOrders }) => {
  const { t } = useTranslation();
  const customerName = useAppSelector(
    (state) => state.persistedReducer.customer.code
  );

  const rowData = React.useMemo(() => workOrders, [workOrders]);
  const [columnDefs] = React.useState([
    {
      field: 'date_of_orders',
      headerName: t('date'),
      maxWidth: 150,
      filter: 'agTextColumnFilter',
      sortable: true,
      cellRenderer: (params: any) => {
        return convertStdDateString(params.value);
      },
    },

    {
      field: 'work_order_number',
      headerName: t('work_order_no'),
      maxWidth: 180,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      field: 'work_order_status',
      headerName: t('work_status'),
      maxWidth: 150,
      hide: customerName === 'buz',
    },
    {
      field: 'asset_id',
      headerName: t('asset_id'),
      maxWidth: 150,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      field: 'actions_performed',
      headerName: t('action_s_performed'),
      width: 150,
      maxWidth: 250,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'components_category',
      headerName: t('component_category'),
      maxWidth: 200,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      field: 'sub_component_categories',
      headerName: t('component_sub_category'),
      maxWidth: 250,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      field: 'description',
      headerName: t('work_order_description'),
      maxWidth: 600,
      tooltipField: 'description',
    },
  ]);

  // Filter function - adjust as needed
  const filterFunction = (node: any) => {
    // Replace this logic with the desired filtering logic
    return !!node.data?.isActive;
  };

  return (
    <ListWrapper>
      <BaseTableList
        rowData={rowData}
        columnDefs={columnDefs}
        filter={filterFunction}
        pagination={true}
        paginationPageSize={20}
      />
    </ListWrapper>
  );
};
